import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js';

Fancybox.bind('[data-fancybox]', {
  groupAll: true,
  Thumbs: {
    showOnStart: false,
    type: 'classic',
  },
});
